import React from "react";
import {
  Dashboard,

  ProductsCategory, Products, Groups, Categories, Layout, Utils, Coupons,

  InvoiceCategory, Licenses, Invoices, ProductSubscription, Balances, Payouts,

  AnalyticsCategory, Analytics, AnalyticsNew, Reports,

  CommsCategory, Feedback, Appeals, Tickets,

  CustomizationCategory, CustomizationNavigation,

  DomainsCustom, EmailsCustom,

  FraudCategory, Security, Audit, FraudBlack, FraudWhite,

  Developers, DevelopersDocs, DevelopersEmbed, DevelopersWebhook, DevelopersWebhookLog,

  CustomizationDocs, CustomizationThemes, CustomizationPages,

  Subscription, Upselling, Addon,

  AppStore, Settings, ShareAndEarn, Fees, PlansAndPricing,

  CustomersDashboard, CustomersAffiliate, FraudDisputes, CustomersAnalytics, PaymentLinks, POS,

} from "./icons/icons";


export const mainNav = (pathname) => {

  return [
    {
      name: "Dashboard",
      id: "dashboard",
      url: pathname === "/",
      to: "/",
      icon: <Dashboard /> ,
    },

    {
      name: "Products",
      id: "products",
      url:
          (pathname === "/products" && "/products") || pathname.includes("/products/new") && "/products/new" || pathname.includes('/products/edit') && "/products/edit/:id" ||
          (pathname === "/groups" && "/groups") || (pathname.includes("/groups/new")) || (pathname.includes("/groups/edit")) ||
          (pathname === "/categories" && "/categories") || (pathname.includes("/categories/new")) || (pathname.includes("/categories/edit")) ||
          (pathname === "/sort" && "/sort") ||
          (pathname === "/upselling" && "/upselling") ||
          (pathname === "/addons" && "/addons") ||
          (pathname === "/coupons" && "/coupons") ||
          (pathname === "/utils" && "/utils"),
      icon: <ProductsCategory />,
      children: [
        {
          name: "Products",
          url: "/products",
          icon: <Products />
        },
        // {
        //   name: "Marketplace",
        //   url: "/settings/marketplace/general",
        //   icon: <Shop />
        // },
        {
          name: "Groups",
          url: "/groups",
          icon: <Groups />
        },
        {
          name: "Categories",
          url: "/categories",
          icon: <Categories />
        },
        {
          name: "Layout",
          url: "/sort",
          icon: <Layout />,
          mobile: true
        },
        {
          name: "Upselling",
          url: "/upselling",
          icon: <Upselling />
        },
        {
          name: "Addons",
          url: "/addons",
          icon: <Addon />
        },
        {
          name: "Utils",
          url: "/utils",
          icon: <Utils />
        },
        {
          name: "Coupons",
          url: "/coupons",
          icon: <Coupons />,
        },
      ]
    },

    {
      name: "Payments",
      id: "invoices",
      url:
            (pathname === "/invoices" && "/invoices") || (pathname.includes("/invoices/") && "/invoices/:id") ||
            (pathname === "/subscriptions" && "/subscriptions") || (pathname.includes("/subscriptions/") && "/subscriptions/:id") ||
            (pathname === "/balances" && "/balances") ||
            (pathname === "/licenses" && "/licenses") || (pathname.includes("/licenses/") && "/licenses/:id") ||
            (pathname === "/links" && "/links") || (pathname.includes("/links/") && "/links/:id") || (pathname.includes("/links/") && "/links/edit/:id") ||
            (pathname === "/payouts" && "/payouts") ||
            (pathname === "/pos" && "/pos"),
      icon: <InvoiceCategory />,
      children: [
        /*{
          name: "Balances",
          url: "/balances",
          icon: <Balances />  ,
        },
        {
          name: "Payouts",
          url: "/payouts",
          icon: <Payouts />  ,
        },*/
        {
          name: "Invoices",
          url: "/invoices",
          icon: <Invoices />  ,
        },
        {
          name: "Subscriptions",
          url: "/subscriptions",
          icon: <ProductSubscription />,
        },
        {
          name: "Licenses",
          url: "/licenses",
          icon: <Licenses />,
        },
        {
          name: "Links",
          url: "/links",
          icon: <PaymentLinks />,
          isBeta: false,
        },
        {
          name: "PoS",
          url: "/pos",
          icon: <POS />,
          isBeta: false,
        },
      ]
    },

    {
      name: "Analytics",
      id: "analytics",
      url:
          (pathname === "/analytics" && "/analytics") ||
          (pathname === "/analytics/stats" && "/analytics/stats") ||
          (pathname === "/analytics/reports" && "/analytics/reports"),
      icon: <AnalyticsCategory />,
      children: [
        {
          name: "Stats",
          url: "/analytics/stats",
          icon: <AnalyticsNew />,
        },
        {
          name: "Reports",
          url: "/analytics/reports",
          icon: <Reports />,
        },
      ]
    },

    {
      name: "Customers",
      id: "customers",
      url:
          (pathname === "/customers" && "/customers") ||
          (pathname.includes("/customers/analytics") && "/customers/analytics/:id") ||
          (pathname.includes("/customers/affiliate") && "/customers/affiliate/:id") ||
          (pathname === "/customers/affiliate" && "/customers/affiliate"),
      icon: <CustomersDashboard />,
      children: [
        {
          name: "Analytics",
          url: "/customers/analytics",
          icon: <CustomersAnalytics />,
        },
        {
          name: "Affiliate",
          url: "/customers/affiliate",
          icon: <CustomersAffiliate />,
        },
      ]
    },

    {
      name: "Comms",
      id: "comms",
      url: pathname.startsWith("/appeals") || pathname.startsWith("/feedback") || pathname.startsWith("/tickets") || pathname.startsWith("/questions"),
      icon: <CommsCategory />,
      children: [
        {
          name: "Tickets",
          url: "/tickets",
          icon: <Tickets />
        },
        {
          name: "Feedback",
          url: "/feedback",
          icon: <Feedback />
        },
        {
          name: "Appeals",
          url: "/appeals",
          icon: <Appeals />
        },
        // {
        //   name: "Questions",
        //   url: "/questions",
        //   icon: <Questions />
        // }
      ]
    },

    {
      name: "Online Store",
      id: "customization",
      url: (pathname === "/customization") ||
          (pathname.startsWith("/customization/documentation")) ||
          (pathname.startsWith("/customization/store")) ||
          (pathname.startsWith("/customization/themes")) ||
          (pathname.startsWith("/customization/pages")) ||
          (pathname.startsWith("/customization/pages/new")) ||
          (pathname.startsWith("/customization/navigation")) ||
          pathname === "/domains" || pathname.startsWith("/domains") || pathname.includes("/customization/domains") ||
          pathname === "/emails" || pathname.startsWith("/emails") || pathname.includes("/customization/emails"),
      icon: <CustomizationCategory />,
      children: [
        {
          name: "Documentation",
          url: "/customization/documentation",
          icon: <CustomizationDocs />
        },
        {
          name: "Themes",
          url: "/customization/themes",
          icon: <CustomizationThemes />
        },
        {
          name: "Pages",
          url: "/customization/pages",
          icon: <CustomizationPages />
        },
        {
          name: "Navigation",
          url: "/customization/navigation",
          icon: <CustomizationNavigation />
        },
        {
          name: "Domains",
          url: "/customization/domains",
          icon: <DomainsCustom />,
        },
        {
          name: "Emails",
          url: "/customization/emails",
          icon: <EmailsCustom />,
        }
      ]
    },

    {
      name: "Fraud Shield",
      id: "fraud_shield",
      url: (pathname === "/fraud") ||
          (pathname.startsWith("/fraud/sessions")) ||
          (pathname.startsWith("/fraud/dashboard")) ||
          (pathname.startsWith("/fraud/disputes")) ||
          (pathname.startsWith("/fraud/audit")) ||
          (pathname.startsWith("/fraud/blacklist")) ||
          (pathname.startsWith("/fraud/whitelist")),
      icon: <FraudCategory />,
      children: [
        {
          name: "Dashboard",
          url: "/fraud/dashboard",
          icon: <Dashboard />
        },
        {
          name: "Security",
          url: "/fraud/sessions",
          icon: <Security />
        },
        {
          name: "Disputes",
          url: "/fraud/disputes",
          icon: <FraudDisputes />
        },
        {
          name: "Audit Trail",
          url: "/fraud/audit",
          icon: <Audit />
        },
        {
          name: "Blacklists",
          url: "/fraud/blacklist",
          icon: <FraudBlack />
        },
        {
          name: "Whitelists",
          url: "/fraud/whitelist",
          icon: <FraudWhite />
        }
      ]
    },

    {
      name: "Paylix Earn",
      id: "share-and-earn",
      url: "/share-and-earn",
      to: "/share-and-earn",
      icon: <ShareAndEarn />,
      isNew: true,
    },
    {
      name: "App Store",
      id: "app-store",
      url: "/app-store",
      to: "/app-store",
      icon: <AppStore />,
    },

    {
      name: "Developers",
      id: "developers",
      url: pathname === "/developer" ||
          (pathname.startsWith("/developer")) ||
          (pathname.includes("/developer/webhooks/all")) ||
          (pathname.includes("/developer/webhooks/logs")),
      icon: <Developers />,
      children: [
        {
          name: "Documentation",
          url: "https://developers.paylix.gg/#introduction",
          icon: <DevelopersDocs />,
          attributes: {
            target: "_blank",
            rel: "documentation"
          }
        },
        {
          name: "Embed",
          url: "/developer/embed",
          icon: <DevelopersEmbed />,
        },
        {
          name: "Webhooks",
          url: "/developer/webhooks/all",
          icon: <DevelopersWebhook />,
        },
        {
          name: "Webhook Logs",
          url: "/developer/webhooks/logs",
          icon: <DevelopersWebhookLog />,
        }
      ]
    },

    {
      name: "Fees",
      id: "fees",
      url: "/fees",
      to: "/fees",
      icon: <Fees />,
      isNew: true,
    },
    {
      name: "Plans & Billing",
      id: "plans-and-billing",
      url: "/plan-n-pricing",
      to: "/plan-n-pricing",
      icon: <PlansAndPricing />,
    },
    {
      name: "Subscription",
      id: "subscription",
      url: "/subscription",
      to: "/subscription",
      icon: <Subscription />,
    },

    {
      name: "Settings",
      id: "settings",
      url: "/settings",
      to: "/settings",
      icon: <Settings />,
    },

    // {
    //   name: "Affiliate Link",
    //   id: "referrals",
    //   url: pathname.includes("/referrals"),
    //   to: "/referrals",
    //   icon: <Referral />,
    // }
  ]
}
